import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorSummaryComponent } from '../error-summary/error-summary.component';
import { ErrorMessage } from '../models/error-message.model';
import { ViewModelService } from '../shared/view-model.service';

@Component({
   selector: 'app-step-abort',
   standalone: true,
   imports: [ErrorSummaryComponent],
   templateUrl: './step-abort.component.html',
   styleUrl: './step-abort.component.scss',
})
export class StepAbortComponent implements OnInit {
   reasonCode: string = '';
   stepAbortTitle: string = '';
   stepAbortSubTitle: string = '';
   stepAbortMessage: string = '';

   public vm = inject(ViewModelService);
   private route = inject(ActivatedRoute);

   ngOnInit(): void {
      this.reasonCode = this.route.snapshot.params['reasonCode'];

      if (!this.vm.content) {
         console.error('Content not loaded');
         return;
      }

      if (this.reasonCode === 'NotMyAddress') {
         this.stepAbortTitle = this.vm.content.stepAbortNotMyAddressTitle;
         this.stepAbortSubTitle = this.vm.content.stepAbortNotMyAddressSubTitle;
         this.stepAbortMessage = this.vm.content.stepAbortNotMyAddressMessage;

         this.vm.error = new ErrorMessage(this.stepAbortTitle, this.stepAbortMessage);
      } else if (this.reasonCode === 'PortalRegistrationNotAllowed') {
         this.stepAbortTitle = this.vm.content.stepAbortPortalNotAvailableTitle;
         this.stepAbortSubTitle = this.vm.content.stepAbortPortalNotAvailableSubTitle;
         this.stepAbortMessage = this.vm.content.stepAbortPortalNotAvailableMessage;

         this.vm.error = new ErrorMessage(
            this.vm.content.stepAbortPortalNotAvailableMessageTitle,
            this.stepAbortMessage
         );
      } else {
         this.stepAbortTitle = this.vm.content.stepAbortUnknownErrorTitle;
         this.stepAbortSubTitle = this.vm.content.stepAbortUnknownErrorSubTitle;
         this.stepAbortMessage = this.vm.content.stepAbortUnknownErrorMessage;

         this.vm.error = new ErrorMessage(this.stepAbortTitle, this.stepAbortMessage);
      }
   }

   logout(): void {
      window.open('/', '_self');
   }
}
